import React from 'react';
import './Alert.css';

interface AlertProps {
    isOpen: boolean;
    title?: string;
    message: string;
    confirmText?: string;
    onConfirm: () => void;
}

export const Alert: React.FC<AlertProps> = ({
    isOpen,
    title = '알림',
    message,
    confirmText = '확인',
    onConfirm
}) => {
    if (!isOpen) return null;

    return (
        <div className="alert-overlay" onClick={onConfirm}>
            <div className="alert-container" onClick={(e) => e.stopPropagation()}>
                <div className="alert-content">
                    <h3 className="alert-title">{title}</h3>
                    <p className="alert-message">{message}</p>
                </div>
                <div className="alert-footer">
                    <button className="alert-button confirm" onClick={onConfirm}>
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};
